<template>
	<div
		:class="[
			'personifiable-user',
			{
				'personifiable-user--disabled': disabled
			}
		]"
		@click="!disabled && $emit('userSelected', user)"
	>
		<helio-avatar
			:user="{ image: user.picture }"
			class="personifiable-user__avatar"
		/>

		<div class="personifiable-user__informations">
			<h3 class="personifiable-user__title">
				{{ user.first_name }} {{ user.last_name }}

				<template v-if="disabled">
					| {{ $t('header.personification.not-personifiable') }}
				</template>
			</h3>

			<p class="personifiable-user__subtitle">
				{{ user.title }} - {{ user.agency }}
			</p>
		</div>
	</div>
</template>

<script>
import Avatar from '../../../avatar/Avatar.vue';

export default {
	components: {
		'helio-avatar': Avatar,
	},

	props: {
		user: {
			type: Object,
			required: true,
		},

		disabled: {
			type: Boolean,
			default: false,
			required: false,
		},
	},
};
</script>

<style lang="scss" src="./personifiable-user.scss" />
